import { Theme } from '../../../types/shared'
import { TextAlign, TextBaseline } from '../../constants/common'
import { FONT_SIZE, OFFSET, PADDING, SETTINGS_HEIGHT } from '../../constants/common'
import {
  chartDarkTheme,
  chartLightTheme,
  elementDarkTheme,
  elementLightTheme,
  generalColors,
  indicatorDarkTheme,
  indicatorLightTheme,
} from '../constants'
import { ISettings, OHLCType } from './interfaces'

// large & ta

const center = {
  barWidth: 2,
  barMargin: 0,
  border: 1,
}

const fontSize = {
  S: 8,
  M: 10,
  XXXL: 24,
}

export const BE_LARGE_CHART_WITH_OVERLAYS_CHART_SETTINGS = (theme: Theme): ISettings => ({
  ChartSettings: {
    general: {
      Colors: {
        ...chartLightTheme,
        [Theme.light]: chartLightTheme,
        [Theme.dark]: chartDarkTheme,
      },
      settingsHeight: SETTINGS_HEIGHT,
    },
    center,
    top: {
      height: 20,
      baseline: TextBaseline.top,
      ticker: {
        margin: { left: -46, top: -4 },
        font: {
          size: fontSize.XXXL,
          style: 'bold',
        },
      },
      ohlc: {
        margin: {
          top: 2,
          left: 15,
          right: 15,
        },
        font: {
          size: fontSize.S,
          textAlign: TextAlign.left,
          baseline: TextBaseline.top,
        },
        type: OHLCType.singleLine,
      },
      change: {
        margin: {
          top: 1,
          right: 40,
        },
        font: {
          size: fontSize.M,
          style: 'bold',
        },
      },
    },
    right: {
      width: 50,
      axis: {
        margin: {
          left: 0,
        },
        font: {
          size: fontSize.S,
          lineHeight: fontSize.S,
          padding: {
            top: PADDING.XXXS,
            bottom: PADDING.XS,
            left: PADDING.XXS,
            right: PADDING.XXS,
          },
        },
      },
    },
    bottom: {
      height: 20,
      baseline: TextBaseline.top,
      axis: {
        margin: {
          top: 3,
        },
        font: {
          size: fontSize.S,
        },
      },
    },
    left: {
      width: 50,
      overlayLabel: {
        labelSpacing: 12,
        margin: {
          top: 6,
          left: 4,
        },
        font: {
          size: FONT_SIZE.S,
          weight: 'bold',
        },
      },
      timeframe: {
        margin: {
          top: 0,
          left: 35,
        },
        font: {
          size: fontSize.M,
          weight: '900',
          family: 'Lato, sans-serif',
        },
      },
      volumeAxis: {
        margin: {
          left: 40,
        },
        font: {
          size: fontSize.S,
        },
      },
    },
  },
  IndicatorSettings: {
    general: {
      height: 140,
      Colors: theme === Theme.light ? indicatorLightTheme : indicatorDarkTheme,
    },
    center,
    top: {
      height: 20,
    },
    right: {
      width: 50,
      axis: {
        margin: {
          left: -2,
        },
        font: {
          size: fontSize.S,
          lineHeight: fontSize.S,
          padding: {
            top: PADDING.XXXS,
            bottom: PADDING.XS,
            left: PADDING.XXS,
            right: PADDING.XXS,
          },
        },
      },
    },
    bottom: {
      height: 20,
    },
    left: {
      width: 50,
      indicatorLabel: {
        labelSpacing: 1,
        margin: {
          top: OFFSET.S,
          left: OFFSET.M,
        },
        font: {
          size: fontSize.M,
          style: 'bold',
          lineHeight: fontSize.M,
        },
      },
    },
  },
  MarketSentimentSettings: {
    general: {
      Colors: theme === Theme.light ? chartLightTheme : chartDarkTheme,
    },
    center: {
      barWidth: 3,
      barMargin: 1,
      border: 1,
    },
    top: {
      height: 0,
    },
    bottom: {
      height: 12,
    },
    left: {
      width: 0,
    },
    right: {
      width: 30,
    },
  },
  ColorsSettings: generalColors,
  ThumbSettings: {
    size: 8,
    touchSize: 16,
    color: '#ddd',
    borderWidth: 1,
    borderColor: '#999',
  },
  ElementSettings: {
    Colors: theme === Theme.light ? elementLightTheme : elementDarkTheme,
    defaultFill: '#1e6dc066',
    defaultTransparentFill: '#1e6dc000',
  },
})
